var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("li", { staticClass: "vehicle-form__checkbox-item" }, [
    _c("label", { staticClass: "vehicle-form__checkbox-label" }, [
      _c(
        "div",
        {
          staticClass:
            "i-checkbox i-checkbox_success vehicle-form__checkbox vehicle-form__checkbox_base vehicle-form__checkbox_font-weight_normal",
          class: { "i-checkbox_disabled": _vm.isDisabled },
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.isSelected,
                expression: "isSelected",
              },
            ],
            staticClass: "i-checkbox__real",
            attrs: { type: "checkbox", disabled: _vm.isDisabled },
            domProps: {
              checked: Array.isArray(_vm.isSelected)
                ? _vm._i(_vm.isSelected, null) > -1
                : _vm.isSelected,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.isSelected,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.isSelected = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.isSelected = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.isSelected = $$c
                }
              },
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "i-checkbox__faux" }),
          _vm._v(" "),
          _c("div", { staticClass: "vehicle-form__checkbox-text" }, [
            _c("div", { staticClass: "vehicle-form__checkbox-sign" }, [
              _vm._v(_vm._s(_vm.option.name)),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }